module.exports = __webpack_public_path__ + "static/media/team.1d05f79c.gif";